import { createExcelFile } from "../../../../../util/excelUtil";

const STATIC_VIEW_EXPORT_NAMES = {
  plan_my_day: "plan-my-day",
  orders_data_triage: "orders-in-data-triage",
  newly_allocated_orders: "newly-allocated-orders",
  high_iteration_orders: "high-iteration-orders",
  aging_orders: "aging-orders",
  pending_review: "pending-review",
  my_weekly_orders: "my-weekly-orders",
  awaiting_response_orders: "awaiting-response-orders",
  awaiting_at_response: "awaiting-response-orders",
  orders_near_duedate: "orders-nearing-due-date",
  allocation_review_request: "allocation-review-requested",
  action_needed_orders: "action-needed-orders",
  regional_leads_weekly_orders: "regional-leads-weekly-orders",
};

export const getSuggestionExportFileName = (
  staticViewType,
  fallback = "smart-suggestion-orders",
) => {
  const mappedName = STATIC_VIEW_EXPORT_NAMES[staticViewType];
  const normalizedName = mappedName || String(staticViewType || fallback)
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

  return `${normalizedName || fallback}.xlsx`;
};

export const exportTableData = async ({
  rows,
  columns,
  getDisplayName,
  fileName,
  sheetName,
  getValue = (row, column) => row?.[column] ?? "",
}) => {
  if (!rows?.length || !columns?.length) return;

  const data = rows.map((row) =>
    Object.fromEntries(
      columns.map((column) => [
        getDisplayName(column),
        getValue(row, column),
      ]),
    ),
  );
  const blob = await createExcelFile([{ name: sheetName, data }]);
  if (!blob) return;

  if (window.navigator?.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, fileName);
    return;
  }

  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
};